<div class="border rounded-large overflow-hidden">
  <div class="relative image-wrapper" *ngIf="bannerImage$ | async as imageData">
    <fcom-image [scale]="false" [imageData]="imageData" [fillParent]="true"></fcom-image>
  </div>
  <div class="ps-medium white-bg">
    <ng-content></ng-content>
  </div>
</div>
